import "./ButtonIcon.css";
import cn from "classnames";
import type { ComponentProps, FC } from "react";
import { Icon } from "../common/Icon";

interface ButtonIconProps extends ComponentProps<"button"> {
	icon: ComponentProps<typeof Icon>["name"];
	size?: number;
}

export const ButtonIcon: FC<ButtonIconProps> = (props) => {
	const {
		icon,
		className,
		size,
		type = "button",
		children: _,
		...rest
	} = props;
	return (
		<button className={cn("btn-icon", className)} type={type} {...rest}>
			<Icon name={icon} size={size ?? 24} />
		</button>
	);
};
